import { ClientSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'
import { Link } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

interface Props {
  onClickAdd: () => void
  data: any[]
  projectData: any
  columns: any[]
}

const ShippingRequest: React.FC<Props> = ({ projectData, columns, data }) => {
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const userRoleId = profile?.roleId || 0
  const isHideScanReceivePile = [2, 7, 8].includes(userRoleId)
  const isHideCreateShippingRequest = [2, 7, 8, 21].includes(userRoleId)

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title'></div>
        <div className='card-toolbar'>
          {!isHideScanReceivePile && (
            <Link to={`/project/${projectData?.id}/pile-scan`}>
              <button className='btn btn-sm btn-primary me-2'>
                <KTSVG
                  path='/media/icons/duotune/arrows/arr075.svg'
                  svgClassName='svg-icon-1x svg-primary'
                />
                <span>สแกนรับเสา</span>
              </button>
            </Link>
          )}
          {projectData.saleOrder && !isHideCreateShippingRequest && (
            <Link
              to={`/shipping-request/create?saleOrderId=${projectData.saleOrder.id}&projectId=${projectData.id}`}>
              <button className='btn btn-sm btn-primary'>
                <KTSVG
                  path='/media/icons/duotune/arrows/arr017.svg'
                  svgClassName='svg-icon-1 svg-primary'
                />
                <span>สร้างคำร้อง</span>
              </button>
            </Link>
          )}
        </div>
      </div>

      <div className='card-body px-0'>
        <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} />
      </div>
    </div>
  )
}

export default ShippingRequest
